import Vue from 'vue'
import App from './App.vue'
import { ModalPlugin  } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import {router} from '@/router'
import i18n from './_helpers/lang'
import './directives'
import {Params} from '@/_utils/params'
import PortalVue from 'portal-vue'
import clickOutside from '@mysummar/summar-vue/src/directives/clickOutside'
import store from '@/_utils/store'
import device from 'vue-device-detector-js'
import PosthogPlugin from '@/_utils/posthog'

Vue.config.productionTip = false

Vue.use(ModalPlugin)
Vue.use(VueSweetalert2)
Vue.use(PortalVue);
Vue.use(device);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.directive('click-outside', clickOutside);

Params.InitParams().then(() => {
    Vue.use(PosthogPlugin)

    new Vue({
        el: '#app',
        router,
        i18n,
        render: h => h(App),
        store,
        mounted() {
            // Ocultar el efecto de carga después de que la instancia de Vue esté montada
            if(document.getElementById('loading-init')!=null) {
                document.getElementById('loading-init').remove();
                document.getElementById('loading-style').remove();
            }
        }
    }).$mount('#app')
});
